<script setup>
import { ref, watch, onUnmounted } from 'vue';

const props = defineProps({
    closable: {
        type: Boolean,
        default: false,
    },
    open: {
        type: Boolean,
        default: false,
    },
    type: {
        type: String,
        default: 'success',
    },
    duration: {
        type: Number,
        default: 1000 * 10,
    },
    dense: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(['update:open']);

const isOpen = ref(props.open);
let timeoutId = null;

watch(() => props.open, (opened) => {
    isOpen.value = opened;

    if (props.closable && opened) {
        timeoutId = setTimeout(() => {
            isOpen.value = false;
            emit('update:open', false);
        }, props.duration);
    }

    if (props.closable && !opened) {
        if (timeoutId) clearTimeout(timeoutId);
    }
});

function close() {
    isOpen.value = false;
    emit('update:open', false);
}

onUnmounted(() => {
    if (timeoutId) clearTimeout(timeoutId);
});
</script>

<template>
    <Transition name="fade">
        <div v-if="isOpen" class="alert" :class="{ 'py-1': dense, [`is-${type}`]: true }">
            <slot></slot>
            <button aria-label="button" v-if="closable" type="button" aria-hidden="true" class="alert__close-btn icon-times-circle-regular" @click="close"></button>
        </div>
    </Transition>
</template>
